"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert = exports.description = exports.name = exports.id = void 0;
exports.id = 'insomnia-3';
exports.name = 'Insomnia v3';
exports.description = 'Insomnia export format 3';
const convert = rawData => {
    let data = null;
    try {
        data = JSON.parse(rawData);
    }
    catch (error) {
        return null;
    }
    if (data.__export_format !== 3) {
        // Bail early if it's not the legacy format
        return null;
    }
    // This is the target export format so nothing needs to change
    return data.resources;
};
exports.convert = convert;
//# sourceMappingURL=insomnia-3.js.map